import React from "react"
import LayersBanner from "./mappedin-layers.banner"
import LayersGraphiclist from "./mappedin-layers.graphiclist"
import useLayersImages from "./useLayersImages"

export default function MappedinLayers({ overlayLayer }) {
  const assets = useLayersImages()

  return (
    <>
      <LayersBanner />
      <LayersGraphiclist overlayLayer={overlayLayer} assets={assets} />
    </>
  )
}
